import { useSelector } from 'react-redux';

import { ApplicationState } from '../../state';

export const useStoreData = () =>
    useSelector((state: ApplicationState) => state);
